import { ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export interface IOfferFactItemProps {
  title: string;
  value: string;
}

export const OfferFactItem: React.FC<IOfferFactItemProps> = ({ title, value }) => {
  return (
    <div className={style['item']}>
      <ArticleParagraph2 color="black_100">{title}</ArticleParagraph2>
      <div className={style['divider']} />
      <ArticleParagraph2 color="black_100">{value}</ArticleParagraph2>
    </div>
  );
};
